<template>
  <div class="blog-details-wrap ptb-100">
    <div class="container">
      <div class="row gx-5">
        <div
          class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2"
        >
          <SideBar />
        </div>

        <div
          class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1"
        >
          <article>
            <div class="post-img">
              <img
                src="../../assets/images/blog/single-blog-1.jpg"
                alt="Image"
              />
            </div>
            <ul class="post-metainfo list-style">
              <li><i class="ri-user-add-line"></i><a href="#">Admin</a></li>
              <li>
                <i class="ri-chat-4-line"></i>
                <a href="#">No Comment</a>
              </li>
            </ul>
            <h2>Providing Quick Solution To Essential Health Services</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do
              eiusmod tempor incididunt labore et dolore sitor magna aliqua.
              Quis ipsum suspendisse ultrices <strong>gravida</strong>. Risus
              commodo viverra manas accumsan lacus vel facilisis. Lorem ipsum
              dolor sit amet, consectetur adipiscing elit.
            </p>
            <p>
              No sea takimata sanctus est Lorem
              <a href="#">Ipsum</a> dolor sit amet. Lorem ipsum dolor sit amet,
              consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et.
            </p>
            <div class="row gx-4 mt-30">
              <div class="col-md-6">
                <div class="post-img">
                  <img src="../../assets/images/blog/blog-1.jpg" alt="Image" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="post-img">
                  <img src="../../assets/images/blog/blog-2.jpg" alt="Image" />
                </div>
              </div>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do
              eiusmod tempor incididunt labore et dolore sitor magna aliqua.
              Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
              manas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit.
            </p>
            <blockquote class="wp-block-quote">
              <div class="wp-quote-text">
                <p>
                  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
                  cum fuga ab, eum numquam ea dolores quae takimata sanctus est
                  Lorem amet ducimus Lorem ipsum, dolor sit amet consectetur
                  adipisicing amet"
                </p>
                <h5>Rosalline Kelan</h5>
              </div>
            </blockquote>
            <div class="post-img">
              <img
                src="../../assets/images/blog/single-blog-2.jpg"
                alt="Image"
              />
            </div>
            <h3>We Are Satisfied With Your Recovery</h3>
            <ul class="content-feature-list style5 list-style">
              <li>
                <i class="ri-check-double-line"></i>Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed diam nonumy eirmod tempor.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Advisory membership elitr,
                sed diam nonumy eirmod tempor invidunt ut labor et dolore magna.
              </li>
              <li>
                <i class="ri-check-double-line"></i>If you do not have enough
                time, you will always be able to work and do what you want.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Irmad temporarily involved
                labor and doll magna alicum erat, sed diam voluptua. Vero Eos
                and accused and fair.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Labor and Love Magna Aliquam
                Irat, Sed Diam Valupatua. Vero eos et accusam et justo dolores
                et ea ribam.
              </li>
            </ul>
            <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua at vero amet dolor sit consect.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur
              <strong>adipisicing</strong> elit, sed do eiusmod tempor quis
              nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in
              <a href="#">sed</a> uia non numquam eius modi tempora incidunt ut
              labore dolor labore et dolore magna aliquyam.
            </p>
          </article>

          <div class="post-meta-option">
            <div class="row gx-0 align-items-center">
              <div class="col-md-7 col-12">
                <div class="post-tag">
                  <span>Tags:</span>
                  <ul class="tag-list list-style">
                    <li>
                      <router-link to="/blog-details">Health</router-link>,
                    </li>
                    <li>
                      <router-link to="/blog-details">Dentist</router-link>,
                    </li>
                    <li>
                      <router-link to="/blog-details">Doctor</router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-5 col-12 text-md-end text-start">
                <div class="post-share w-100">
                  <span>Share:</span>
                  <ul class="social-profile list-style style1">
                    <li>
                      <a target="_blank" href="https://facebook.com">
                        <i class="ri-facebook-line"></i>
                      </a>
                    </li>
                    <li>
                      <a target="_blank" href="https://twitter.com">
                        <i class="ri-twitter-line"></i>
                      </a>
                    </li>
                    <li>
                      <a target="_blank" href="https://instagram.com">
                        <i class="ri-instagram-line"></i>
                      </a>
                    </li>
                    <li>
                      <a target="_blank" href="https://linkedin.com">
                        <i class="ri-linkedin-line"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="post-author">
            <div class="post-author-img">
              <img src="../../assets/images/blog/author-4.jpg" alt="Image" />
            </div>

            <div class="post-author-info">
              <h4>Alince Gomej</h4>
              <p>
                Claritas est etiam amet sinicus, qui sequitur lorem ipsum semet
                coui lectorum. Lorem ipsum dolor voluptatem corporis blanditiis
                sadipscing elitr sed diam nonumy eirmod amet.
              </p>

              <ul class="social-profile list-style style1">
                <li>
                  <a target="_blank" href="https://facebook.com">
                    <i class="ri-facebook-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com">
                    <i class="ri-twitter-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://instagram.com">
                    <i class="ri-instagram-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://linkedin.com">
                    <i class="ri-linkedin-line"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="comment-box-wrap">
            <div class="comment-box-title mb-30">
              <h4><span>3</span> Comments</h4>
            </div>

            <div class="comment-item-wrap">
              <div class="comment-item">
                <div class="comment-author-img">
                  <img src="../../assets/images/blog/author-1.jpg" alt="mage" />
                </div>
                <div class="comment-author-wrap">
                  <div class="comment-author-info">
                    <div class="row align-items-start">
                      <div
                        class="col-md-9 col-sm-12 col-12 order-md-1 order-sm-1 order-1"
                      >
                        <div class="comment-author-name">
                          <h5>
                            Olivic Dsuza
                            <span class="comment-date"> / 22 Feb, 2022 </span>
                          </h5>
                        </div>
                      </div>
                      <div
                        class="col-md-3 col-sm-12 col-12 text-md-end order-md-2 order-sm-3 order-3"
                      >
                        <a href="#cmt-form" class="reply-btn">
                          <i class="ri-reply-fill"></i>Reply
                        </a>
                      </div>
                      <div
                        class="col-md-12 col-sm-12 col-12 order-md-3 order-sm-2 order-2"
                      >
                        <div class="comment-text">
                          <p>
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam erat.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="comment-item reply">
                <div class="comment-author-img">
                  <img src="../../assets/images/blog/author-2.jpg" alt="mage" />
                </div>
                <div class="comment-author-wrap">
                  <div class="comment-author-info">
                    <div class="row align-items-start">
                      <div
                        class="col-md-9 col-sm-12 col-12 order-md-1 order-sm-1 order-1"
                      >
                        <div class="comment-author-name">
                          <h5>
                            Everly Leah
                            <span class="comment-date"> /30 Jan, 2021 </span>
                          </h5>
                        </div>
                      </div>
                      <div
                        class="col-md-3 col-sm-12 col-12 text-md-end order-md-2 order-sm-3 order-3"
                      >
                        <a href="#cmt-form" class="reply-btn">
                          <i class="ri-reply-fill"></i>
                          Reply
                        </a>
                      </div>
                      <div
                        class="col-md-12 col-sm-12 col-12 order-md-3 order-sm-2 order-2"
                      >
                        <div class="comment-text">
                          <p>
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="comment-item">
                <div class="comment-author-img">
                  <img src="../../assets/images/blog/author-3.jpg" alt="mage" />
                </div>
                <div class="comment-author-wrap">
                  <div class="comment-author-info">
                    <div class="row align-items-start">
                      <div
                        class="col-md-9 col-sm-12 col-12 order-md-1 order-sm-1 order-1"
                      >
                        <div class="comment-author-name">
                          <h5>
                            Michel Jackson
                            <span class="comment-date"> / 12 Jan, 2021 </span>
                          </h5>
                        </div>
                      </div>
                      <div
                        class="col-md-3 col-sm-12 col-12 text-md-end order-md-2 order-sm-3 order-3"
                      >
                        <a href="#cmt-form" class="reply-btn">
                          <i class="ri-reply-fill"></i>
                          Reply
                        </a>
                      </div>
                      <div
                        class="col-md-12 col-sm-12 col-12 order-md-3 order-sm-2 order-2"
                      >
                        <div class="comment-text">
                          <p>
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore et dolore magna aliquyam erat.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="cmt-form">
            <div class="comment-box-title mb-25">
              <h4>Leave A Comment</h4>
              <p>
                Your email address will not be published. Required fields are
                marked.
              </p>
            </div>

            <form action="#" class="comment-form">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <textarea
                      name="messages"
                      id="messages"
                      cols="30"
                      rows="10"
                      placeholder="Please Enter Your Comment Here"
                    ></textarea>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      required
                      placeholder="Name*"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      required
                      placeholder="Email Address*"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <input
                      type="number"
                      name="phone"
                      id="phone"
                      required
                      placeholder="Phone Number*"
                    />
                  </div>
                </div>
              </div>

              <div class="row align-items-center">
                <div class="col-md-12">
                  <div class="checkbox">
                    <input type="checkbox" id="test_1" />
                    <label for="test_1">
                      Save my name,email,website addres in this browser for the
                      next time I commnet.
                    </label>
                  </div>
                </div>
                <div class="col-md-12 mt-20">
                  <button class="btn style2">Post A Comment</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SideBar from "./SideBar.vue";

export default defineComponent({
  name: "BlogDetails",
  components: {
    SideBar,
  },
});
</script>